const TOKEN_KEY = 'parachute-token';
const USER_KEY = 'parachute-user';

function decodeJwtPayload(token: string): unknown | null {
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    // base64url -> base64
    const payloadB64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = payloadB64.padEnd(payloadB64.length + ((4 - (payloadB64.length % 4)) % 4), '=');
    const json = atob(padded);
    return JSON.parse(json) as unknown;
  } catch {
    return null;
  }
}

function isJwtExpired(token: string): boolean {
  const payload = decodeJwtPayload(token) as Record<string, unknown> | null;
  const exp = typeof payload?.exp === 'number' ? payload.exp : null;
  if (!exp) return false; // If no exp claim, let backend handle it.
  return exp * 1000 <= Date.now();
}

/**
 * Bearer token for API calls: prefers `parachute-token`, else `token` on `parachute-user`
 * (matches prior ClientLicenses / Analysis client behavior).
 */
export function getParachuteAuthToken(): string | null {
  try {
    const direct = sessionStorage.getItem(TOKEN_KEY);
    if (direct) {
      if (isJwtExpired(direct)) {
        clearParachuteAuthSession();
        return null;
      }
      return direct;
    }
    const raw = sessionStorage.getItem(USER_KEY);
    if (!raw) return null;
    const u = JSON.parse(raw) as { token?: string };
    const token = typeof u?.token === 'string' && u.token ? u.token : null;
    if (!token) return null;
    if (isJwtExpired(token)) {
      clearParachuteAuthSession();
      return null;
    }
    return token;
  } catch {
    return null;
  }
}

export function setParachuteAuthToken(token: string | undefined | null): void {
  try {
    if (token) {
      sessionStorage.setItem(TOKEN_KEY, token);
    } else {
      sessionStorage.removeItem(TOKEN_KEY);
    }
  } catch {
    /* ignore quota / private mode */
  }
}

/** Removes cached token and user blob (call on logout). */
export function clearParachuteAuthSession(): void {
  try {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
  } catch {
    /* ignore */
  }
}
